import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../../../../../init-store';
import { isSipRoomAgent } from '../../../config/selectors';
import { MODAL_TYPES } from '../modal-type/constants';
import { selectModalType } from '../modal-type/selectors';

export const selectIsDebugMenuOpen = (state: RootState) => {
    return isSipRoomAgent(state) && selectModalType(state) === MODAL_TYPES.debugMenu;
};

export const selectDebugMenuReport = (state: RootState) => state.dtmf.debugMenu.report;

export const selectDrawConferenceDisabledValue = (state: RootState) => state.dtmf.debugMenu.drawConferenceDisabled;

export const selectIsDrawConferenceDisabled = createSelector(
    selectIsDebugMenuOpen,
    selectDrawConferenceDisabledValue,
    (isDebugMenuOpen, isDrawConferenceDisabled) => isDebugMenuOpen && isDrawConferenceDisabled
);
